import _ from "lodash";
import React from "react";

import { Field } from "redux-form";
import { FunctionField } from "react-admin";
import { CategoryComponentInput, CategoryComponent } from "./CategoryComponent";

const CategoryArticleInput = props => {
  return (
    <Field
      name={props.source}
      component={CategoryComponentInput}
      label={props.label}
      categoryType="article"
      format={category_data => {
        const values = _.map(category_data, item => {
          return item.category;
        });
        return values;
      }}
      parse={selectedOptions => {
        return _.map(selectedOptions, category => {
          return { category: category };
        });
      }}
    />
  );
};
CategoryArticleInput.defaultProps = {
  addLabel: true
};

const CategoryArticleField = props => (
  <FunctionField
    {...props}
    render={() => {
      return (
        <CategoryComponent
          value={props.record[props.source]}
          categoryType="article"
        />
      );
    }}
  />
);
CategoryArticleField.defaultProps = { addLabel: true };

export { CategoryArticleField, CategoryArticleInput };
